/* eslint-disable max-lines */
import { useContext, useState, useEffect } from 'react';
import { Context as AuthContext } from '../../contexts/AuthContext';
import { Badge, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Media } from 'reactstrap';
import UserService from '../../services/User';
import BaseNavBarNotificationItem from './BaseNavBarNotificationItem';
import BaseNavbarNotificationModal from './BaseNavbarNotificationModal';

const MobileNotificationsNavbar = () => {
  const { userNotifications, token, updateUserNotifications }: any = useContext(AuthContext);
  const [notificationList, setNotificationList] = useState<any>([]);
  const [modalShowAllNotifications, setModalShowAllNotifications] = useState(false);
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const toggleNotifications = () => setNotificationsOpen((isOpen) => !isOpen);

  const _readNotification = async (id: string) => {
    await UserService(token).readNotification({ id: [id] });
    updateUserNotifications();
  };

  const clearAllNotifications = async () => {
    const notificationIds = notificationList.map((item: any) => {
      return item.id;
    });

    await UserService(token).readNotification({ id: notificationIds });
    updateUserNotifications();
  };

  const notificationListItems = () => {
    return notificationList?.data?.map((item: any) => {
      return <BaseNavBarNotificationItem key={`notification-list-${item?.id}`} item={item} />;
    });
  };

  useEffect(() => {
    setNotificationList(userNotifications);
  }, [userNotifications]);

  return (
    <>
      {modalShowAllNotifications && (
        <BaseNavbarNotificationModal isOpen={true} toggle={() => setModalShowAllNotifications(false)} />
      )}
      <Dropdown nav isOpen={notificationsOpen} toggle={toggleNotifications} style={{ marginLeft: 15 }}>
        <DropdownToggle className="pr-0" nav style={{ paddingLeft: '0' }}>
          <Media className="align-items-center">
            <i className="fas fa-bell" style={{ fontSize: 'x-large', paddingTop: '7px' }}></i>
            <Badge
              color="primary"
              className="badge-md badge-circle badge-floating border-white"
              style={{
                width: '1.5rem',
                height: '1.5rem',
                position: 'absolute',
                // top: '25%',
                transform: 'translate(-50%, -50%)',
                margin: '6px 22px',
                padding: '0',
              }}
            >
              {notificationList.length}
            </Badge>
          </Media>
        </DropdownToggle>
        <DropdownMenu
          className="dropdown-menu-arrow"
          right
          container="body"
          positionFixed
          style={{
            zIndex: '99999999',
            width: 'calc(100vw - 1rem)',
            minWidth: 'auto',
            maxWidth: '460px',
            marginTop: 'env(safe-area-inset-top)',
          }}
        >
          <DropdownItem className="noti-title" header tag="div">
            <h6 className="text-overflow m-0">
              Notifications
              <div style={{ float: 'right' }}>
                <a onClick={toggleNotifications} style={{ cursor: 'pointer' }} aria-label="Close notifications">
                  <i className="fas fa-2x fa-times"></i>
                </a>
              </div>
            </h6>
          </DropdownItem>
          {notificationListItems()}
          <div className="col-12 text-right pb-2">
            <button className="btn btn-sm btn-primary" onClick={() => setModalShowAllNotifications(true)}>
              Show All
            </button>
            <button className="btn btn-sm btn-warning" onClick={clearAllNotifications}>
              Clear All
            </button>
          </div>
        </DropdownMenu>
      </Dropdown>
    </>
  );
};

export default MobileNotificationsNavbar;
